module.exports = __webpack_public_path__ + "media/images/icons/house-5cc2fea5157d82b404c6f9934afac1c1.svg";